import { http } from '@shared/api';
import type { MediaScope, PresignedDownload, PresignedUpload } from '../model/types';

interface CreateUploadRequest {
  scope: MediaScope;
  contentType: string;
  sizeBytes: number;
  fileName?: string;
}

export const mediaApi = {
  createUpload: (body: CreateUploadRequest) =>
    http.post('media/uploads', { json: body }).json<PresignedUpload>(),

  confirmUpload: (mediaId: string) =>
    http.post(`media/uploads/${mediaId}/confirm`).json<void>(),

  getDownloadUrl: (mediaId: string) =>
    http.get(`media/${mediaId}/download`).json<PresignedDownload>(),

  // §15.2 (v1.1) — DELETE. Backend pока не каскадит:
  // если media уже привязан к сущности, ссылка останется висячей.
  remove: (mediaId: string) => http.delete(`media/${mediaId}`).json<void>(),
};
